import { render, staticRenderFns } from "./IncidenteProteccionCivilIcon.vue?vue&type=template&id=f532daee&scoped=true"
import script from "./IncidenteProteccionCivilIcon.vue?vue&type=script&lang=js"
export * from "./IncidenteProteccionCivilIcon.vue?vue&type=script&lang=js"
import style0 from "./IncidenteProteccionCivilIcon.vue?vue&type=style&index=0&id=f532daee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f532daee",
  null
  
)

export default component.exports